import { primitiveTokens, semanticThemeTokens } from "@appretio/ui-kit";
import { style } from "@vanilla-extract/css";

export const formContainer = style({
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["4x"]
});

export const categoryRow = style({
  display: "flex",
  gap: primitiveTokens.sizing["2x"]
});

export const messageArea = style({
  width: "100%",
  minHeight: "8rem",
  resize: "vertical",
  padding: primitiveTokens.sizing["3x"],
  borderRadius: primitiveTokens.sizing["1x"],
  border: `1px solid ${semanticThemeTokens.divider.backgroundColor}`,
  background: "transparent",
  color: "inherit",
  font: "inherit"
});

export const charCounter = style({
  textAlign: "right",
  opacity: 0.7,
  fontSize: primitiveTokens.type.xs,
  marginTop: primitiveTokens.sizing["1x"]
});

export const consentNote = style({
  opacity: 0.7,
  fontSize: primitiveTokens.type.xs,
  margin: 0
});

/** Why Send is disabled — same muted idiom as the consent note. */
export const sendBlockedHint = style({
  opacity: 0.7,
  fontSize: primitiveTokens.type.xs,
  margin: 0
});

export const successBlock = style({
  display: "flex",
  flexDirection: "column",
  gap: primitiveTokens.sizing["3x"]
});

export const successTitle = style({
  margin: 0,
  fontWeight: 600
});

export const successHint = style({
  margin: 0,
  opacity: 0.7,
  fontSize: primitiveTokens.type.xs
});

/** A clipboard write that failed — same idiom as the picker's errorText. */
export const copyFailedText = style({
  color: semanticThemeTokens.input.invalid.borderColor,
  fontSize: primitiveTokens.type.xs
});

export const restoreLinkUrl = style({
  display: "block",
  padding: primitiveTokens.sizing["2x"],
  borderRadius: primitiveTokens.sizing["1x"],
  border: `1px solid ${semanticThemeTokens.divider.backgroundColor}`,
  fontSize: primitiveTokens.type.xs,
  wordBreak: "break-all",
  userSelect: "all"
});
